import React, { useEffect, useState } from "react";
import Swal from "sweetalert2"; // ✅ SweetAlert2 import

const InstallPWA = () => {
  const [isReady, setIsReady] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsInstalled(true);
      return;
    }

    // Check if deferredPrompt exists
    if (window.deferredPrompt) setIsReady(true);

    const interval = setInterval(() => {
      if (window.deferredPrompt) {
        setIsReady(true);
        clearInterval(interval);
      }
    }, 1000);

    // After install
    window.addEventListener("appinstalled", () => {
      setIsInstalled(true);
      window.deferredPrompt = null;
    });

    return () => clearInterval(interval);
  }, []);

  const handleInstall = async () => {
    if (!window.deferredPrompt) {
      // ❌ SweetAlert confirm instead of simple alert
      await Swal.fire({
        icon: "info",
        title: "Install not ready yet",
        text: "Use the browser icon ⬇️ to install manually",
        confirmButtonText: "OK",
      });
      return;
    }

    // ✅ Ask user to confirm installation
    const { isConfirmed } = await Swal.fire({
      title: "Install App?",
      text: "Do you want to install this app?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Install",
      cancelButtonText: "Cancel",
    });

    if (isConfirmed) {
      window.deferredPrompt.prompt();
      const choice = await window.deferredPrompt.userChoice;
      window.deferredPrompt = null;
      setIsReady(false);

      if (choice.outcome === "accepted") {
        Swal.fire({
          icon: "success",
          title: "Installed!",
          text: "The app has been installed successfully.",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Installation Cancelled",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    }
  };

  if (isInstalled) return null; // hide button if already installed

  return (
    <button
      onClick={handleInstall}
      style={{
        width: "100%",
        padding: "10px 16px",
        background: "transparent",
        border: "none",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: "500",
        color: isReady ? "#16a34a" : "#9ca3af",
        borderBottom: "1px solid #e5e7eb",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      <span style={{ fontSize: "14px" }}>⬇️</span>
      {isReady ? "Install App" : "Preparing Install..."}
    </button>
  );
};

export default InstallPWA;